import { useMemo } from 'react';
import {EntryBlock, EntryStage} from "../../types";

export function useStageInfo(stage: EntryStage, block: EntryBlock) {
    return useMemo(() => {
        return {
            stage,
            stageName: getStageName(stage),
            stagePath: getStagePath(stage, block)
        }
    }, [stage, block]);

    function getStageName(stage: EntryStage): string {
        switch (stage) {
            case 3:
                return "二次審査";
            case 4:
                return "三次審査";
            case 5:
                return "四次審査";
            case 6:
                return "セミファイナル";
            case 7:
                return "ファイナル";
            default:
                return ""
        }
    }

    function getStagePath(stage: EntryStage, block?: EntryBlock): string {
        const blockName = block?.toLowerCase();
        switch (stage) {
            case 3:
                return `/list/2/${blockName ?? ""}`;
            case 4:
                return `/list/3/${blockName ?? ""}`;
            case 5:
                return `/list/4`;
            case 6:
                return `/list/5`;
            case 7:
                return `/list/6`;
            default:
                return `/list`;
        }
    }
}